module.exports = __webpack_public_path__ + "static/media/CrossGrey.5a902cfb.svg";